// extracted by mini-css-extract-plugin
export default {"list":"segment-branding-sidebar-block_list__1b6tk","listItem":"segment-branding-sidebar-block_listItem__bzW+H","footer":"segment-branding-sidebar-block_footer__UqVai"};